module.exports = __webpack_public_path__ + "img/serialnumber_bg.0bc3ada6.png";